import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-clearance-request',
  templateUrl: './clearance-request.component.html',
  styleUrls: ['./clearance-request.component.scss']
})
export class ClearanceRequestComponent {
  @Output() retry = new EventEmitter<void>();
  @Output() contactSupport = new EventEmitter<void>();
  @Output() nextModal = new EventEmitter<void>();

}